<template>
  <div>
    <v-dialog
      v-model="isShowUserGroupModal"
      :overlay="false"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar flat class="card-toolbar-title">
          <v-toolbar-title>Selected Users for User Group: {{ selectedUserGroupInfo.userGroupName }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click.native="isShowUserGroupModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-app-bar>
        <div>
          <v-tabs
            slot="extension"
            v-model="currentTab"
            centered
            color="secondary"
            slider-color="orange"
          >
            <v-tab href="#tabCurrent">
              Current
            </v-tab>
            <v-tab href="#tabHistory">
              History
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="currentTab">
            <v-tab-item id="tabCurrent">
              <v-card text>
                <v-container fluid grid-list-md>
                  <v-form ref="form">
                    <v-card-actions>
                      <v-layout row justify-center>
                        <v-flex xs12 sm4>
                          <v-autocomplete
                            id="addUser"
                            v-model="addedUserId"
                            :items="userList"
                            :rules="required"
                            class="required"
                            item-text="userUID"
                            return-object
                            name="addUser"
                            label="Enter User ID to Add"
                          />
                        </v-flex>
                        <v-flex xs12 sm1>
                          <v-btn
                            fab
                            dark
                            color="primary"
                            @click.native="addUser"
                          >
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-form>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentSearch"
                        append-icon="search"
                        label="Filter Users"
                        single-line
                      />
                      <v-data-table
                        :headers="currentUserTableHeaders"
                        :items="usersForUserGroupC"
                        :search="currentSearch"
                        class="elevation-1"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td class="justify-center">
                              <v-btn icon class="mx-0" @click="removeUser(props.item)">
                                <v-icon color="error">delete</v-icon>
                              </v-btn>
                            </td>
                            <td>{{ props.item.userUID }}</td>
                            <td>{{ props.item.fullName }}</td>
                            <td><span v-for="groupName in props.item.groups" :key="groupName">{{ groupName }}<br /></span></td>
                            <td>{{ props.item.createdBy }}</td>
                            <td>{{ props.item.createdOn | formatDate }}</td>
                            <td>{{ props.item.lastModifiedBy }}</td>
                            <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
            <v-tab-item id="tabHistory">
              <v-card text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-card-actions>
                        <v-text-field
                          v-model="historySearch"
                          append-icon="search"
                          label="Filter Users"
                          single-line
                          hide-details
                        />
                      </v-card-actions>
                      <v-data-table
                        :headers="historyUserTableHeaders"
                        :items="userGroupHistory"
                        :search="historySearch"
                        class="elevation-1"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td :class="props.item.action === 'add' ? 'add-text-color' : 'remove-text-color'">
                              {{ props.item.action === 'add' ? 'Add' : 'Remove' }}
                            </td>
                            <td>{{ props.item.user.userUID }}</td>
                            <td>{{ props.item.createdBy }}</td>
                            <td>{{ props.item.createdOn | formatDate }}</td>
                            <td>{{ props.item.lastModifiedBy }}</td>
                            <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card>
    </v-dialog>
    <manage-users-remove-user-modal />
  </div>
</template>

<script>
import ManageUsersRemoveUserModal from './ManageUsersRemoveUserModal'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'manage-users-by-user-group-modal',
  components: {
    ManageUsersRemoveUserModal
  },
  data() {
    return {
      currentTab: 'tabCurrent',
      currentSearch: '',
      historySearch: '',
      addedUserId: '',
      required: [
        v => !!v.userUID || 'Required'
      ],
      currentUserTableHeaders: [{
        text: 'Action',
        value: false,
        sortable: false
      },
      {
        text: 'Users',
        value: 'userUID'
      },
      {
        text: 'Name',
        value: 'fullName'
      },
      {
        text: 'Role',
        value: 'groups'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Modified By',
        value: 'modifiedBy'
      },
      {
        text: 'Modified On',
        value: 'modifiedOn'
      }
      ],
      historyUserTableHeaders: [{
        text: 'Status',
        value: 'user.recordInactiveFlag'
      },
      {
        text: 'Users',
        value: 'user.userUID'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Modified By',
        value: 'modifiedBy'
      },
      {
        text: 'Modified On',
        value: 'modifiedOn'
      }
      ]
    }
  },
  computed: {
    ...mapState('manageUsers', ['usersForUserGroup', 'userList', 'userGroupHistory', 'selectedUserGroupInfo', 'showUserGroupModal']),
    ...mapGetters('oktaGroups', ['groupNames']),
    usersForUserGroupC: function() {
      this.usersForUserGroup.forEach(user => {
        if (user.oktaUser && user.oktaUser.profile) {
          user.fullName = user.oktaUser.profile.lastName + ', ' + user.oktaUser.profile.firstName
        }
        if (user.oktaUser && user.oktaUser.groupIds) {
          user.groups = this.groupNames(user.oktaUser.groupIds)
          user.groupsSort = user.groups.join(',')
        }
      })
      return this.usersForUserGroup
    },
    isShowUserGroupModal: {
      get() {
        return this.showUserGroupModal
      },
      set(value) {
        this.setShowUserGroupModal(value)
      }
    }
  },
  methods: {
    ...mapActions('manageUsers', ['addUserGroupForUser']),
    ...mapMutations('manageUsers', ['setShowUserGroupModal', 'setShowRemoveUserModal', 'setSelectedUser']),
    removeUser(selectedUser) {
      this.setSelectedUser(selectedUser)
      this.setShowRemoveUserModal(true)
    },
    addUser() {
      if (this.$refs.form.validate()) {
        this.addUserGroupForUser({ user: this.addedUserId, group: this.selectedUserGroupInfo })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-text-color {
    color: $color-success;
  }

  .remove-text-color {
    color: $color-danger
  }

  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }
</style>
